import changes from './cleanup-changes-zh'

/** AI 图纸清理（第 5 阶段，计划 Task 10，设计 §11）。占位符与 cleanup-en.ts 相同。 */
export default {
  title: '用 AI 清理我的图纸',
  intro:
    '如果您的图纸未通过图纸检查，gisify 可以在您提交之前帮您修正。原图会保留，不会提交任何内容，市政局的 AI 只读取图纸的摘要，而不是文件本身。',
  link: '获取修正此图纸的帮助',
  round: '第 {{n}} 轮，共 {{max}} 轮',
  explanation: 'AI 的说明',
  errorRow: '图层 {{layer}} 上的 {{type}}',
  errorRowsMore: '还有 {{count}} 项',
  start: {
    file: '图纸（DWG 或 DXF，最大 {{mb}} MB）',
    crs: '图纸的坐标系',
    button: '上传并检查',
    uploading: '正在上传…',
    processedBy:
      '原图会保留，不会提交任何内容，市政局的 AI（{{provider}}，{{where}}）只读取图纸的摘要，而不是文件本身。',
  },
  provider: {
    anthropic: 'Anthropic API 接口',
    bedrock: 'AWS Bedrock 服务',
    openai: 'OpenAI 服务',
    ollama: 'Ollama 服务器',
  },
  processedIn: {
    anthropic_api: '由 Anthropic 在 AWS 之外处理',
    singapore_only: '仅在新加坡处理',
    united_states_only: '仅在美国处理',
    any_aws_region: '在 AWS 选择的任一 AWS 区域处理',
    openai_api: '由 OpenAI 处理',
    own_server: '在您的 Ollama 服务器上处理',
  },
  step: {
    queued: '等待开始…',
    reading: '正在读取图纸…',
    checking: '正在运行图纸检查…',
    asking_ai: '正在向 AI 征求建议…',
    applying: '正在应用您的更改…',
    writing: '正在保存新图纸…',
  },
  failures: {
    before: '开始时的问题',
    now: '当前的问题',
    none: '图纸已通过检查。',
    onLayer: '位于 {{layer}}',
    count: '发现 {{count}} 处',
  },
  status: {
    uploading: '图纸未完成上传。请停止此次清理并重新开始。',
    stopped: '此次清理已停止。',
    failed: '此次清理无法继续。',
    submitted: '清理后的图纸现在是此案件的图纸。请照常提交。',
    expired: '此次清理在 7 天无活动后已关闭。',
    superseded: '此次清理针对的是案件较早的修订版，已关闭。',
  },
  batch: {
    title: 'gisify 找到的修正',
    accept: '接受这些修正',
    saveR2000: '保存为 AutoCAD 2000：省略图纸空间和其他 {{count}} 项',
    saveR2000Detail:
      '省略：{{paperSpace}} 个图纸空间项目、{{objects}} 个对象、{{displayCodes}} 项显示设置、{{xdata}} 项扩展数据、{{reactors}} 个链接和 {{layers}} 个未使用的图层。',
    held: '另有 {{count}} 项修正将在下一轮提供。',
    textToMtextUntick: '没有这项修正，新文件将无法保存这些标注：在您勾选它或在 CAD 中修正之前，本轮会停止。',
  },
  op: {
    rename_layer: '将图层 {{from}} 重命名为 {{to}}',
    explode_inserts: '将 {{layer}} 上的 {{count}} 个块分解为其图形',
    scale_units: '将图纸从{{unit}}换算为米',
    close_outline: '闭合 {{layer}} 上的轮廓（缺口小于 1 毫米）',
    join_pieces: '将 {{layer}} 上首尾相接的线段连接成单一轮廓（共 {{count}} 个）',
    show_layer: '打开图层 {{layer}}',
    remove_empty_layer: '删除空图层 {{layer}}',
    remove_degenerate: '删除 {{layer}} 上 {{count}} 个长度为零的图形',
    remove_duplicate: '删除 {{layer}} 上 {{count}} 个重复的图形',
    text_to_mtext: '将 {{layer}} 上的 {{count}} 个标注保存为多行文字，使 AutoCAD 2000 能保留其字符（文字内容不变）',
  },
  unit: { m: '米', mm: '毫米', cm: '厘米', ft: '英尺' },
  question: {
    title: '第 {{n}} 题，共 {{total}} 题',
    guess: '建议的答案',
    reason: '原因',
    byRule: '由 gisify 建议',
    byAi: '由 AI 建议',
    accept: '接受',
    change: '选择其他答案',
    skip: '跳过',
    choose: '您的答案',
    previous: '上一题',
    next: '下一题',
    answeredAccept: '您已接受此项。',
    answeredReject: '您已跳过此项。',
    allAnswered: '每道问题都已作答。准备好后请按“应用”。',
    layers: '图层：{{layers}}',
  },
  ask: {
    choose_site_boundary: '哪个图形是地块边界？',
    assign_layer: '{{layer}} 应归入哪个标准图层？',
    assign_shapes: '这 {{count}} 个图形应归入哪个土地用途图层？',
    set_units: '这张图纸是以什么单位绘制的？',
    attach_label: '标注 {{text}} 属于哪个地块？',
    label_plot: '这个地块是什么土地用途？',
    remove_layers: '删除这些图层（{{group}}）？',
    remove_entities: '删除 {{layer}} 上的 {{type}} 项目吗？gisify 无法将它们保存到新文件中。',
  },
  answer: { shape: '图形 {{id}}', remove: '删除它们' },
  group: { title_block: '图框标题栏', dimensions: '尺寸标注', furniture: '家具', other: '其他' },
  ruleReason: {
    writer_cannot_carry: 'AutoCAD 2000 文件无法保存这些项目。请在此删除它们，或在 CAD 中修正后重新上传。',
  },
  pointOut: {
    title: '请在 CAD 中修正这些问题',
    help: 'gisify 不会移动点或面积。请在您的 CAD 程序中修正这些问题，然后重新上传。',
    fixInCad: '请在 CAD 中修正',
    outsideJurisdiction: '图纸不在市政局的辖区内。请检查您选择的坐标系，或使用定位工具放置图纸。',
    kind: {
      block_too_large: '这个块太大，无法在此分解。请在 CAD 中分解它。',
      arc_chain: '这些线段包含圆弧，gisify 不会连接它们。请在 CAD 中连接。',
      too_large: '这项修改太大，清理无法在一轮内完成。请在 CAD 中修改。',
    },
  },
  view: {
    title: '您的图纸',
    loading: '正在加载图纸…',
    failed: '无法显示图纸。',
    cut: '图纸的部分内容未在此显示：其点数超过此视图可绘制的数量。',
    role: {
      site_boundary: '地块边界',
      landuse: '土地用途',
      labels: '土地用途标注',
      context: '辅助细节',
      other: '其他图层',
    },
  },
  actions: {
    apply: '应用',
    use: '使用此图纸',
    useNote: '清理后的图纸将成为您在此案件中的图纸。您仍需照常提交，并会运行常规检查。',
    download: '下载清理后的 DXF',
    revert: '返回第 {{n}} 轮',
    stop: '停止',
    retry: '重试',
  },
  ai: {
    failed: 'AI 无法提出修正建议。请重试。',
    limit: '请联系您的市政局以继续。',
    roundFull: '本轮已没有空间容纳 AI 的建议。下一轮将再询问 AI。',
  },
  limit: { rounds: '您已用完全部 10 轮。请在 CAD 中修正剩余的问题，或下载部分清理后的 DXF。' },
  refusal: {
    not_home_tenant: '此清理功能只能由本市政局的人员使用。',
    not_found: '找不到此案件。',
    actor_not_permitted: '只有拥有此案件的顾问才能清理其图纸。',
    drawing_cleanup_off: '市政局已关闭图纸清理功能。',
    ai_not_configured: '市政局尚未为图纸清理设置 AI。',
    ai_region_unavailable: '市政局选择的 AI 已不再提供。请市政局重新选择。',
    register_server_not_configured: '市政局尚未完成图纸检查的设置。',
    stage_held_externally: '另一个系统正持有此案件，因此无法在此更改其图纸。',
    stage_locked: '此案件的图纸在当前阶段无法更改。',
    body_invalid: '无法读取该请求。请重新加载页面后重试。',
    upload_rejected: '无法清理该文件。',
    cleanup_not_found: '找不到此次清理。请重新加载页面。',
    cleanup_in_progress: '此案件已有一个进行中的清理。',
    cleanup_closed: '此次清理已关闭。',
    upload_missing: '图纸未完整上传。请重新开始。',
    cleanup_busy: '仍有一轮正在运行。请等待其完成。',
    round_mismatch: '此次清理已经推进。请重新加载页面查看当前轮次。',
    answer_invalid: '无法使用该答案。',
    revert_invalid: '已无法恢复到该轮。',
    retry_not_offered: '没有可以重试的内容。',
    round_limit: '10 轮已全部用完。',
    nothing_to_use: '尚未应用任何更改。',
    cleanup_use_failed: '无法将清理后的图纸放入此案件。请重试。',
    edit_invalid: '有一项更改已不再适用于图纸，因此本轮已撤销。请检查您的答案后再次应用。',
    unsupported_entities: '新文件无法保存某些项目。请通过这里的问题删除它们、勾选保留它们的修正，或在 CAD 中修正。',
    too_complex: '这张图纸太大或太复杂，无法在此清理。请在 CAD 中减少块后保存，或将其拆分。',
    check_not_run: '图纸检查无法运行。请重试。',
    round_timeout: '本轮耗时过长，已被停止。请重试。',
    unreadable_file: '无法读取图纸。请在 CAD 中重新保存后开始新的清理。',
    stopped: '本轮已停止。',
  },
  uploadRejected: {
    too_large: '文件超过市政局允许的大小。',
    empty: '文件是空的。',
    unsupported_type: '该文件不是与其文件名相符的 DWG 或 DXF 图纸。',
  },
  answerInvalid: {
    needs_item: '此答案需要您取消勾选的修正或您未接受的问题。',
    conflicts_item: '此答案与一项已勾选的修正相冲突。',
    nothing_accepted: '应用之前，请至少接受一项修正或一个答案。',
  },
  changes,
} as const
